import { render, staticRenderFns } from "./form-component-select-from-embedded.vue?vue&type=template&id=04c47fe0&scoped=true"
import script from "./form-component-select-from-embedded.vue?vue&type=script&lang=ts"
export * from "./form-component-select-from-embedded.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c47fe0",
  null
  
)

export default component.exports